import { takeLatest, put } from 'redux-saga/effects';
import {
  OPEN_ORDER_IN_LT_MANAGER,
  OPEN_ORDER_IN_LT_MANAGER_SUCCESS,
  openOrderInLtManager as actionOpenOrderInLtManager,
} from '../actions/orders';
import sendMessageManagerBus from '../../utils/sendMessageManagerBus';
import { safeCall, safeApply } from './errors';

const ORDER_URL = `${process.env.ORDER_URL}`;

function* openOrderInLtManager({
  payload: { orderId },
}: ReturnType<typeof actionOpenOrderInLtManager>) {
  const res = yield safeCall(sendMessageManagerBus, {
    direction: `${ORDER_URL}/${orderId}`,
    urlPattern: `${ORDER_URL}/*`,
    payload: orderId,
  });

  if (!res) {
    window.open(`https://manager.level.travel/orders/all/${orderId}`, '_blank');
    return;
  }

  yield put({ type: OPEN_ORDER_IN_LT_MANAGER_SUCCESS });
}

export default function* () {
  yield takeLatest(OPEN_ORDER_IN_LT_MANAGER, safeApply(openOrderInLtManager));
}
